import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { VideoTrackType } from 'src/app/services/session-call-tracks.service';

export enum VideoTileMenuAction {
  TOGGLE_PIN = 'toggle-pin',
  TOGGLE_FULLSCREEN = 'toggle-fullscreen',
  INSERT_VIDEO = 'insert-video',
  SCREENSHOT = 'screenshot',
}

export interface VideoTileMenuContext {
  participantId: string;
  trackType: VideoTrackType;
  isPinned: boolean;
  isFullscreen: boolean;
}

/**
 * Bridges the screen share annotations toolbar and the active video tile.
 * The toolbar renders the menu; `wb-video-call-participant-id` publishes tile context for
 * the pinned/fullscreen screenshare, and each `session-call-user` tile listens to `action$`
 * but only the tile matching `tileContext` executes — mirroring the existing output bindings.
 */
@Injectable()
export class VideoTileMenuService {
  private readonly _action$ = new Subject<VideoTileMenuAction>();
  private readonly _tileContext$ = new BehaviorSubject<VideoTileMenuContext | null>(null);

  public readonly action$ = this._action$.asObservable();
  public readonly tileContext$ = this._tileContext$.asObservable();

  public perform(action: VideoTileMenuAction): void {
    this._action$.next(action);
  }

  public setTileContext(context: VideoTileMenuContext | null): void {
    this._tileContext$.next(context);
  }

  public get tileContext(): VideoTileMenuContext | null {
    return this._tileContext$.getValue();
  }
}
